import { render, staticRenderFns } from "./barcodeWageProfit.vue?vue&type=template&id=3ad5d70f&scoped=true&"
import script from "./barcodeWageProfit.vue?vue&type=script&lang=js&"
export * from "./barcodeWageProfit.vue?vue&type=script&lang=js&"
import style0 from "./barcodeWageProfit.vue?vue&type=style&index=0&id=3ad5d70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad5d70f",
  null
  
)

export default component.exports